import { AnyAction } from "redux";
import { FETCH_CLASS_OFFERS, RECEIVE_CLASS_OFFERS, SAVE_CLASS_OFFER, SAVE_CLASS_OFFER_SUCCESS, DELETE_CLASS_OFFER, DELETE_CLASS_OFFER_SUCCESS } from "../actionTypes";

interface ClassOfferState {
    isFetching: boolean;
    isSaving: boolean;
    classOffers: any[];
}

const initialState: ClassOfferState = {
    isFetching: false,
    isSaving: false,
    classOffers: [],
}

const classOfferReducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case FETCH_CLASS_OFFERS: return { ...state, isFetching: true };
        case RECEIVE_CLASS_OFFERS: return { ...state, isFetching: false, classOffers: action.payload };
        case SAVE_CLASS_OFFER: return { ...state, isSaving: true };
        case SAVE_CLASS_OFFER_SUCCESS: return { ...state, isSaving: false };
        case DELETE_CLASS_OFFER: return { ...state, isSaving: true };
        case DELETE_CLASS_OFFER_SUCCESS: return { ...state, isSaving: false };
        default: return state;
    }
}
export default classOfferReducer;
